import { Fragment } from 'react'

import { Dialog, Transition } from '@headlessui/react'

import BuyToShareOptions from './BuyToShareOptions'
import styles from './index.module.css'

interface BuyToShareProps {
  isOpen: boolean
  onClose: () => void
}

const BuyToShare = ({ isOpen, onClose }: BuyToShareProps) => {
  return (
    <Transition
      as={Dialog}
      show={isOpen}
      onClose={onClose}
      className={styles.dialogWrapper}
      style={{ zIndex: 2147483003 }}
    >
      <Transition.Child
        as={Fragment}
        enter="ease-out duration-300"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="ease-in duration-200"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <div className={styles.dialogFrame} />
      </Transition.Child>

      <div className={styles.visibilityTransitionWrapper}>
        <div className={styles.visibilityChildContainer}>
          <Transition.Child
            as={BuyToShareOptions}
            enter={styles.enter}
            enterFrom={styles.enterFrom}
            enterTo={styles.enterTo}
            leave={styles.leave}
            leaveFrom={styles.leaveFrom}
            leaveTo={styles.leaveTo}
            onClose={onClose}
          />
        </div>
      </div>
    </Transition>
  )
}

export default BuyToShare
